export const formatAlarmDuration = duration =>
  duration === 0 || duration === '0' ? '< 2' : (duration ?? '-');
